import { Routes } from '@angular/router';
import { PatTokenComponent } from '../../pages/developers/settings/pat-token/pat-token.component';
import { MqttApiComponent } from '../../pages/developers/documentation/mqtt-api/mqtt-api.component';

export const DeveloperLayoutRoutes: Routes = [
    { path: 'documentation/mqtt_api', component: MqttApiComponent},
    { path: 'settings/pat-token', component: PatTokenComponent  },
]
